import { ChangeEvent, Key } from 'react';

import { Box, Tabs, Tab } from '@thirdspacelearning/library';

export type Tab<T> = {
    key: T;
    label: string;
};

type Props<T> = {
    selectedTab: T;
    tabList: Tab<T>[];
    setSelectedTab: (selectedTab: T) => void;
};

const TabsPanel = <T,>({ selectedTab, tabList, setSelectedTab }: Props<T>) => {
    const handleTabChange = (_event: ChangeEvent<unknown>, newValue: T) => {
        setSelectedTab(newValue);
    };

    return (
        <Box
            // sx={sx.wrapper(selectedTab === tabList[0].key)}
            data-testid="page-filter-tabs"
        >
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="tabs selection"
                textColor="primary"
            >
                {tabList.map(({ key, label }) => (
                    <Tab
                        key={key as Key}
                        value={key}
                        label={label}
                        data-testid={`${String(key).toLowerCase()}-tab-button`}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default TabsPanel;
